import React from 'react';
import { FaHome, FaBookOpen, FaGraduationCap, FaSearch, FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      '--primary': '#1a5d1a',
      '--secondary': '#3498db',
      '--dark': '#2c3e50',
      '--gray': '#7f8c8d',
      '--light': '#f8f9fa',
      '--light-gray': '#ecf0f1'
    }}>
      {/* Hero Section with 404 Error */}
        <section style={{
          background: 'linear-gradient(to top, rgba(0, 46, 14, 0.5) 10%, rgba(0, 0, 0, 0.4) 20%, rgba(0,0,0,0)), linear-gradient(135deg, rgba(26, 93, 26, 0.8), rgba(44, 62, 80, 0.9))',
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
          position: 'relative'
        }}>
          <div style={{
            maxWidth: '1200px',
            width: '100%',
            padding: '2rem'
          }}>
            <div style={{
          fontSize: '8rem',
          fontWeight: '900',
          marginBottom: '1rem',
          textShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)',
          opacity: '0.9'
            }}>
          404
            </div>
            
            <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem',
          gap: '1rem'
            }}>
          <FaExclamationTriangle style={{ fontSize: '2rem', color: '#f39c12' }} />
          <h1 style={{
            fontSize: '3rem',
            margin: '0',
            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)',
            fontWeight: '800'
          }}>
            Page Introuvable
          </h1>
            </div>
            
            <p style={{
          fontSize: '1.3rem',
          marginBottom: '3rem',
          textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)',
          maxWidth: '600px',
          margin: '0 auto 3rem',
          lineHeight: '1.6'
            }}>
          La page que vous recherchez n'existe pas ou a été déplacée. 
          Explorez nos ressources académiques ci-dessous.
            </p>
          </div>
        </section>

        {/* Quick Links Section */}
      <section style={{
        padding: '4rem 1rem',
        background: 'var(--light)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '3rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              color: 'var(--dark)',
              marginBottom: '1rem',
              position: 'relative',
              display: 'inline-block'
            }}>
              Où souhaitez-vous aller ?
              <div style={{
                content: "''",
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '80px',
                height: '4px',
                background: 'var(--primary)',
                borderRadius: '2px'
              }}></div>
            </h2>
            <p style={{
              fontSize: '1.2rem',
              color: 'var(--gray)',
              maxWidth: '600px',
              margin: '1.5rem auto 0'
            }}>
              Choisissez parmi nos sections principales
            </p>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem',
            marginBottom: '3rem'
          }}>
            {[
              {
                icon: <FaHome />,
                title: 'Accueil',
                description: 'Retour à la page principale de l\'U2S',
                link: '/'
              },
              {
                icon: <FaGraduationCap />,
                title: 'Contact',
                description: 'Contactez-nous pour toute question ou information',
                link: '/contact'
              },
              {
                icon: <FaBookOpen />,
                title: 'Admissions',
                description: 'Procédures d\'inscription et candidature',
                link: '/admissions'
              },
              {
                icon: <FaSearch />,
                title: 'À Propos',
                description: 'Histoire et mission de l\'université',
                link: '/about'
              }
            ].map((item, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '10px',
                padding: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.4s ease',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '5px',
                  background: 'var(--primary)'
                }}></div>
                
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '1.5rem',
                  color: 'var(--primary)',
                  transition: 'transform 0.3s ease'
                }}>
                  {item.icon}
                </div>
                
                <h3 style={{
                  fontSize: '1.4rem',
                  color: 'var(--dark)',
                  marginBottom: '1rem'
                }}>
                  {item.title}
                </h3>
                
                <p style={{
                  color: 'var(--gray)',
                  lineHeight: '1.6',
                  marginBottom: '1.5rem'
                }}>
                  {item.description}
                </p>
                
                <a
                  href={item.link}
                  style={{
                    display: 'inline-block',
                    background: 'var(--primary)',
                    color: 'white',
                    border: 'none',
                    padding: '0.8rem 2rem',
                    borderRadius: '30px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#144d14';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'var(--primary)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Accéder
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* University Info Section */}
      <section style={{
        padding: '4rem 1rem',
        background: 'white',
        borderTop: '1px solid var(--light-gray)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '3rem',
          alignItems: 'center'
        }}>
          <div>
            <h3 style={{
              fontSize: '2rem',
              color: 'var(--primary)',
              marginBottom: '1.5rem',
              fontWeight: '700'
            }}>
              Université des Sciences de Sébikotane
            </h3>
            <p style={{
              color: 'var(--gray)',
              lineHeight: '1.7',
              marginBottom: '2rem'
            }}>
              Excellence académique et innovation au service du développement. 
              Spécialisée dans les études islamiques et les sciences de l'éducation.
            </p>
            <div style={{
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap'
            }}>
              <button style={{
                background: 'var(--primary)',
                color: 'white',
                border: 'none',
                padding: '1rem 2rem',
                borderRadius: '30px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#144d14';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'var(--primary)';
                e.target.style.transform = 'translateY(0)';
              }}>
                Retour à l'Accueil
              </button>
              
              <button style={{
                background: 'transparent',
                color: 'var(--primary)',
                border: '2px solid var(--primary)',
                padding: '1rem 2rem',
                borderRadius: '30px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(26, 93, 26, 0.1)';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}>
                Nous Contacter
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;